import WarnningModal from "../containers/WarnningModal";

'use strict';

class RegisterUserStore {
    constructor() {
        this.data =  {
            'loginid': '',
        }
        this.openWarinigModal = new WarnningModal();
    }

    getData() {
        this.data.loginid = $('#mail').val();
    }

    valid() {
        this.getData();
        if(this.data.loginid === "") {
            return false;
        }
        return true;
    }
    openWarningModal() {
        this.openWarinigModal.openModal();
    }
}
export default RegisterUserStore;